
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    showButton: {
      type: Boolean,
      default: () => true
    }
  },
  emits: ['click']
})
